import { z } from 'zod'

import { freeRoundNotificationSchema } from './freeRoundNotificationSchema'
import { paymentNotificationSchema } from './paymentNotificationSchema'

const notificationSchemas = [paymentNotificationSchema, freeRoundNotificationSchema] as const
export const USER_NOTIFICATION_CONFIRMATION_TYPE = 'confirmation'

const confirmationNotificationSchema = z.object({
  type: z.literal(USER_NOTIFICATION_CONFIRMATION_TYPE),
  payload: z.union([...notificationSchemas]),
})

const notificationSchema = z.discriminatedUnion('type', [...notificationSchemas, confirmationNotificationSchema])

export const userNotificationsSchema = z.array(notificationSchema)

export type UserNotification = z.infer<typeof notificationSchema>
export type UserNotificationPayload = UserNotification['payload']
